import { EVENT_USER_ID, SET_NO_VIEWERS, SET_USER_COUNTRY, USERNAME_FOUND, USERNAME_NOT_FOUND, USER_ID } from "../constants/authContants";

export const authReducer = (state={username: '', storedAt: '', userID: '', lvcconnectEventUserId: '', country: '', noViewers: '1'}, action) => {


    switch(action.type) {
        case USERNAME_NOT_FOUND:
            return {
                ...state,
                username: '',
                storedAt: ''
            }
        case USERNAME_FOUND:
            return {
                ...state,
                username: action.payload
            }
        case USER_ID:
            return {
                ...state,
                userID: action.payload
            }
        case EVENT_USER_ID:
            return {
                ...state,
                lvcconnectEventUserId: action.payload
            }
        case SET_USER_COUNTRY:
            return {
                ...state,
                country: action.payload
            }
        case SET_NO_VIEWERS:
            return {
                ...state,
                noViewers: action.payload
            }
        default:
            return state
    }
}